export class EvaluationResultDto {
  id = '';
  evaluatedCountry = '';
  creationTimestamp = '';
  evaluationReferenceTimestamp = '';
  lastAccessTimestamp = '';
  validationState!: number;
  isCurrent = false;
}